import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, ExternalLink } from "lucide-react";
import Logo from "./Logo";
import { COLLEGE } from "../lib/data";

export default function Header({ minimal = false }) {
  return (
    <header className="w-full bg-transparent">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between gap-4">
        <Link to="/" className="shrink-0">
          <Logo />
        </Link>
        {!minimal && (
          <div className="hidden md:flex items-center gap-6">
            <a
              href={`mailto:${COLLEGE.email}`}
              className="flex items-center gap-2 text-sm text-slate-700 hover:text-cct-blue transition-colors"
            >
              <Mail className="w-4 h-4 text-cct-blue" />
              {COLLEGE.email}
            </a>
            <a
              href={`tel:${COLLEGE.phone.replace(/[^+\d]/g, "")}`}
              className="flex items-center gap-2 text-sm text-slate-700 hover:text-cct-blue transition-colors"
            >
              <Phone className="w-4 h-4 text-cct-blue" />
              {COLLEGE.phone}
            </a>
            <div className="w-px h-6 bg-slate-300" />
            <a
              href={COLLEGE.mainSite}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 bg-cct-blue text-white text-sm font-medium px-4 py-2 rounded-md hover:bg-[#1a3380] transition-colors"
            >
              Go to main CCT website
              <ExternalLink className="w-4 h-4" />
            </a>
          </div>
        )}
      </div>
    </header>
  );
}
